import { isNil } from 'lodash';
import PropTypes from 'prop-types';
import { isBlank } from '../../../properties/funcs';
import { DEFAULT_INVALID_VALUE } from '../../../../utilities/FormattingUtilities';
import { AdminPages } from '../../AdminPages';
import { DrillInLink } from '../../../links/DrillInLink';
import { buildRootPageTarget } from '../../AdminLinkUtils';

/**
 * Renders a drill-in link to the wireless controller's monitored infrastructure detail page.
 * Only shown for access point devices that have a wirelessController reference.
 * The controller data comes from /ngp/v2/devices API (NOT the admin config API).
 * @param {Object} props
 * @param {Object} props.controller - Wireless controller object with _id and name
 */
const WirelessControllerLink = ({ controller }) => {
    const name = controller?.name;
    const id = controller?._id;
    const isValid = !isBlank(name) && !isNil(id);

    if (!isValid) {
        return <>{DEFAULT_INVALID_VALUE}</>;
    }

    const url = `${buildRootPageTarget(AdminPages.MonitoredInfrastructure)}/${id}`;

    return (
        <DrillInLink to={url} title={name}>
            {name}
        </DrillInLink>
    );
};

WirelessControllerLink.propTypes = {
    controller: PropTypes.shape({
        _id: PropTypes.string,
        name: PropTypes.string,
    }).isRequired,
};

export default WirelessControllerLink;
